import { render, staticRenderFns } from "./BusinessPartnerContactPersonDialog.vue?vue&type=template&id=0f1f2f1a&"
import script from "./BusinessPartnerContactPersonDialog.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerContactPersonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports